<template>
<div class="chapter">
<div class="inner_page">
<div style="page-break-before: always;"></div>
<p class="P_Norm-Center__And__Page_Break"><span>For Sharron Bailey and Lisa Masker. I was truly blessed when it came to my aunts, even if you persist in calling me Fer-Fer.</span></p>
<p class="P_Normal"> </p>
<p class="P_Normal"> </p>
<h1 class="P_Heading_1" id="auto_bookmark_toc_1"><span>Acknowledgments</span></h1>
<p class="P_Normal"> </p>
<p class="P_Normal"> </p>
<p class="P_Normal__And__Left_Indent"><span style=" font-weight: bold; font-size: 1.00em;">NO</span> book is the sole creation of a single individual. I have a huge debt of gratitude and appreciation for the online and in-person “sprinters” who joined me in the writing process. You kept me company, kept me motivated, and held me accountable, making the writing process as fun as it was productive. So I’d like to give a huge THANK YOU to Vanessa M. Knight, Jenn Burke, Livia Grant, Ann Marie Walker, Elizabeth Harmon, Amy Alessio, Heather Novak, and Nicole Leiren. We all write completely different subgenres of romance, but you are proof that the romance community is truly amazing and enabling in the best possible way. So, thank you from the bottom of my heart.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section0004.vue?0a6b5c34